import { render, staticRenderFns } from "./PaypalManageModal.vue?vue&type=template&id=37b56a4e&scoped=true"
import script from "./PaypalManageModal.vue?vue&type=script&lang=js"
export * from "./PaypalManageModal.vue?vue&type=script&lang=js"
import style0 from "./PaypalManageModal.vue?vue&type=style&index=0&id=37b56a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b56a4e",
  null
  
)

export default component.exports